import Btn from './shared/Btn';

/**
 * @param {{ mode: 'guided'|'expert', onChange: (m: 'guided'|'expert') => void, disabled?: boolean }} props
 */
export default function ModeToggle({ mode, onChange, disabled = false }) {
  return (
    <div role="group" aria-label="Edit mode" style={{ display: 'inline-flex', borderRadius: 'var(--ab-radius-sm)', overflow: 'hidden' }}>
      <Btn
        kind={mode === 'guided' ? 'primary' : 'secondary'}
        size="sm"
        onClick={() => onChange('guided')}
        disabled={disabled}
      >
        Guided
      </Btn>
      <Btn
        kind={mode === 'expert' ? 'primary' : 'secondary'}
        size="sm"
        onClick={() => onChange('expert')}
        disabled={disabled}
      >
        Expert
      </Btn>
    </div>
  );
}
